// Core
import React, { useMemo } from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Components
import {
  LineChart,
  LineChartType,
  Series,
  SeriesColorEnum,
} from '../../../../../../layout/elements/LineChart';

// View
import { RingBounceProps } from './RingBounce.types';
import { ChartMode } from '../Trendings.types';

// Constants
const DEFAULT_TRANSLATE_LEGEND: string = 'view.crusher.trendings.ringBounceSensor';

function RingBounce({
  className,
  chartMode,
  testId,
  trendingRingBounceSensorData,
  unitData,
}: RingBounceProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();

  // Generate dynamic ID based on enabled sensors and chart mode to force chart remount
  const chartId = useMemo((): string => {
    const sensorsState: string = String(unitData?.vibrationSensor1Enable || false);
    const baseId: string = `ring-bounce-${chartMode}`;
    return `${baseId}-${sensorsState}`;
  }, [chartMode, unitData?.vibrationSensor1Enable]);

  const series: Series[] = useMemo((): Series[] => [
    {
      name: t('common.cloudConnection'),
      field: 'edgeStatus',
      type: LineChartType.fill,
      date: 'timestamp',
      opposite: true,
    },
    ...(unitData?.vibrationSensor1Enable ? [{
      name: t(`${DEFAULT_TRANSLATE_LEGEND}.legend.vibrationSensor1`),
      field: 'vibrationSensor1',
      type: LineChartType.line,
      date: 'timestamp',
      color: SeriesColorEnum.lightPink,
      unit: '%',
      bullet: true,
      decimals: 2,
      minScale: 0,
      maxScale: 100,
    }] : []),
  ], [t, unitData?.vibrationSensor1Enable]);

  return (
    <LineChart
      activeBullet={chartMode === ChartMode.live || chartMode === ChartMode.liveAggregate}
      className={className}
      data={trendingRingBounceSensorData}
      id={chartId}
      series={series}
      testId={testId}
    />
  );
}

export { RingBounce };
